import { render, staticRenderFns } from "./SanteTns.vue?vue&type=template&id=34913b0c&"
import script from "./SanteTns.vue?vue&type=script&lang=js&"
export * from "./SanteTns.vue?vue&type=script&lang=js&"
import style0 from "./SanteTns.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports